import api from '../lib/api';

export const FETCH_MARKETS = 'FETCH_MARKETS';
export const FETCH_ACTIVE_MARKETS = 'FETCH_ACTIVE_MARKETS';
export const FETCH_MARKET_BRANDS = 'FETCH_MARKET_BRANDS';
export const SELECT_MARKET = 'SELECT_MARKET';
export const MARKET_LOADING = 'MARKET_LOADING';
export const FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA';

function fetchActiveMarkets() {
  const query = {
    active: 'true',
  };
  return (dispatch) => api.getMarkets(query)
    .then((data) => {
      dispatch({ type: FETCH_ACTIVE_MARKETS, payload: data });
      return data;
    });
}

function fetchMarkets() {
  return (dispatch) => api.getMarkets()
    .then((data) => {
      dispatch({ type: FETCH_MARKETS, payload: data });
      return data;
    });
}

function selectMarket(market) {
  return {
    type: SELECT_MARKET,
    payload: market,
  };
}

function fetchDashboardData(query) {
  return (dispatch) => {
    dispatch({ type: MARKET_LOADING, payload: true });

    return api
      .getDashboardData(query)
      .then((data) => {
        dispatch({
          type: FETCH_DASHBOARD_DATA, payload: data,
        });
      })
      .then(() => {
        dispatch({ type: MARKET_LOADING, payload: false });
      })
      .catch(() => {
        dispatch({ type: MARKET_LOADING, payload: false });
      });
  };
}

export default {
  fetchMarkets,
  fetchActiveMarkets,
  selectMarket,
  fetchDashboardData,
  fetchMarketBrands() {
    return (dispatch) => api.getMarketBrands()
      .then((data) => {
        dispatch({ type: FETCH_MARKET_BRANDS, payload: data });
      });
  },
  updateMarket(market, marketId) {
    return async (dispatch) => {
      // on an update: update the market, re-fetch market lists, and re-select the market to update all fields/lists
      try {
        const updatedMarketResponse = await api.updateMarket(market, marketId);
        const updatedMarket = updatedMarketResponse.data;
        await fetchMarkets()(dispatch);
        await fetchActiveMarkets()(dispatch);
        return dispatch(selectMarket(updatedMarket));
      } catch (e) {
        return { hasError: true, errorObject: e };
      }
    };
  },
};
